import React, { useState, useEffect } from 'react';
import { motion } from "framer-motion";
import moment from 'moment';
import axios from "axios";
import 'moment/locale/de'
import "./events.scss";

moment.locale('de')

const Events = () => {
    const [eventData, setEventData] = useState(null);
    const [visibleEvents, setVisibleEvents] = useState(6);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {

        const fetchData = async () => {
            try {
                const eventsRes = await axios.get('https://mkstlorenzen.2ix.de/konzertmeisterApi.php');
                setEventData(eventsRes.data);

                setLoading(false);
            } catch (err) {
                console.error(err);
            }
        };

        fetchData();
    }, []);

    const loadMoreEvents = () => {
        setVisibleEvents(prev => prev + 6);
    }

    return (
        <div className='events'>
            <div className="container">
                <h1>Auftritte und Termine</h1>
                <div className="list">
                    {isLoading ? <div className='loading' /> : eventData.slice(0, visibleEvents).map((item, index) => {
                        const delay = (index % 5) * 0.1;

                        return (
                            <motion.div
                                className="item"
                                key={item.id}
                                initial={{ opacity: 0, y: 100 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay }}
                            >
                                <div className="left">
                                    <span className='day'>{moment(item.start).format('DD')}</span>
                                    <span className='month'>{moment(item.start).format('MMM YY')}</span>
                                </div>
                                <div className="right">
                                    <h3>{item.name}</h3>
                                    <span>{!item.timeUndefined && (moment(item.start).format('HH:mm') + " - " + moment(item.end).format('HH:mm'))}</span>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
                {eventData && visibleEvents < eventData.length && (
                    <button className='loadMore' onClick={loadMoreEvents}>Mehr anzeigen</button>
                )}
            </div>
        </div>
    )
}

export default Events;
